export class EventReservation {
  static fromJSON(json) {
    return new EventReservation(json)
  }

  constructor(json) {
    this.availDetails = json.availDetails
    this.bookingFileId = json.bookingFileId
    this.status = json.status
    this.priceSummary = json.priceSummary
    this.bookingStatus = json.bookingStatus
    this.customer = json.customer
    this.hotel = json.hotel
    this.eventType = json.eventType
    this.totalEvent = json.totalEvent
  }
}

export const EventReservationStatus = {
  FUTURE: 'future',
  PAST: 'past',
  CANCELLED: 'cancelled'
}
